import { useTheme } from "app/shared";
import { FC } from "react";
import { MdOutlineLightbulb, MdQuestionMark } from "react-icons/md";
import styles from "./ProblemSolution.module.scss";

interface ProblemSolutionProps {
  problem: string;
  solution: string;
}

const ProblemSolution: FC<ProblemSolutionProps> = ({ problem, solution }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Problem & Solution</h2>

      <div className={styles.problemCard}>
        <div className={styles.cardHeader}>
          <MdQuestionMark color="#E90092" />
          Problem
        </div>
        <p className={styles.cardContent}>{problem}</p>
      </div>

      <div className={styles.solutionCard}>
        <div className={styles.cardHeader}>
          <MdOutlineLightbulb color="#E90092" />
          Solution
        </div>
        <p className={styles.cardContent}>{solution}</p>
      </div>
    </div>
  );
};

export default ProblemSolution;
